module.exports = __webpack_public_path__ + "img/facebook-icon-wit.763376c5acecc15d340902dadaf41304.svg";